
import { useState } from 'react';

export default function SpawnersSection() {
  const [selectedSpawner, setSelectedSpawner] = useState<any>(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showIbanModal, setShowIbanModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [purchaseInfo, setPurchaseInfo] = useState({
    minecraftUsername: '',
    email: '',
    discord: '',
  });

  const spawners = [
    {
      name: 'Köylü',
      price: '₺50',
      color: 'from-green-400 to-emerald-500',
      image: 'https://public.readdy.ai/ai/img_res/1bcff3eec0a78d1ae23a2b6134e708b8.jpg',
    },
    {
      name: 'Zombi',
      price: '₺45',
      color: 'from-lime-400 to-green-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20zombie%20character%203d%20render%20on%20simple%20dark%20background%20with%20lime%20green%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-zombie-001&orientation=squarish',
    },
    {
      name: 'İskelet',
      price: '₺55',
      color: 'from-gray-300 to-gray-500',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20skeleton%20character%203d%20render%20on%20simple%20dark%20background%20with%20white%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-skeleton-001&orientation=squarish',
    },
    {
      name: 'Creeper',
      price: '₺60',
      color: 'from-green-500 to-lime-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20creeper%20character%203d%20render%20on%20simple%20dark%20background%20with%20bright%20green%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-creeper-001&orientation=squarish',
    },
    {
      name: 'Demir Golem',
      price: '₺80',
      color: 'from-gray-400 to-slate-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20iron%20golem%20character%203d%20render%20on%20simple%20dark%20background%20with%20metallic%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-irongolem-001&orientation=squarish',
    },
    {
      name: 'Örümcek',
      price: '₺40',
      color: 'from-red-400 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20spider%20character%203d%20render%20on%20simple%20dark%20background%20with%20red%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-spider-001&orientation=squarish',
    },
    {
      name: 'Enderman',
      price: '₺120',
      color: 'from-purple-400 to-violet-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20enderman%20character%203d%20render%20on%20simple%20dark%20background%20with%20purple%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-enderman-001&orientation=squarish',
    },
    {
      name: 'Blaze',
      price: '₺150',
      color: 'from-orange-400 to-red-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20blaze%20character%203d%20render%20on%20simple%20dark%20background%20with%20fire%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-blaze-001&orientation=squarish',
    },
    {
      name: 'Cadı',
      price: '₺90',
      color: 'from-indigo-400 to-purple-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20witch%20character%203d%20render%20on%20simple%20dark%20background%20with%20purple%20potion%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-witch-001&orientation=squarish',
    },
    {
      name: 'Slime',
      price: '₺35',
      color: 'from-lime-300 to-green-500',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20slime%20character%203d%20render%20on%20simple%20dark%20background%20with%20bright%20green%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-slime-001&orientation=squarish',
    },
    {
      name: 'Magma Küpü',
      price: '₺100',
      color: 'from-red-500 to-orange-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20magma%20cube%20character%203d%20render%20on%20simple%20dark%20background%20with%20lava%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-magmacube-001&orientation=squarish',
    },
    {
      name: 'Koruyucu',
      price: '₺130',
      color: 'from-cyan-400 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20guardian%20character%203d%20render%20on%20simple%20dark%20background%20with%20cyan%20water%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-guardian-001&orientation=squarish',
    },
    {
      name: 'Piglin',
      price: '₺70',
      color: 'from-pink-400 to-red-500',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20piglin%20character%203d%20render%20on%20simple%20dark%20background%20with%20gold%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-piglin-001&orientation=squarish',
    },
    {
      name: 'Wither İskeleti',
      price: '₺180',
      color: 'from-gray-600 to-black',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20wither%20skeleton%20character%203d%20render%20on%20simple%20dark%20background%20with%20dark%20gray%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-witherskeleton-001&orientation=squarish',
    },
    {
      name: 'Zombi Pigman',
      price: '₺85',
      color: 'from-pink-500 to-green-600',
      image: 'https://readdy.ai/api/search-image?query=minecraft%20zombie%20pigman%20character%203d%20render%20on%20simple%20dark%20background%20with%20pink%20green%20lighting%20professional%20game%20asset%20style%20clean%20isolated%20mob%20showcase&width=400&height=400&seq=spawner-zombiepigman-001&orientation=squarish',
    },
  ];

  const handlePurchaseClick = (spawner: any) => {
    setSelectedSpawner(spawner);
    setShowPurchaseModal(true);
  };

  const handlePurchaseSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!purchaseInfo.minecraftUsername || !purchaseInfo.email || !purchaseInfo.discord) {
      alert('Lütfen tüm alanları doldurun!');
      return;
    }
    setShowPurchaseModal(false);
    setShowIbanModal(true);
  };

  const handleConfirmPayment = async () => {
    const formData = new URLSearchParams();
    formData.append('minecraft_username', purchaseInfo.minecraftUsername);
    formData.append('player_email', purchaseInfo.email);
    formData.append('discord_username', purchaseInfo.discord);
    formData.append('spawner_type', selectedSpawner.name);
    formData.append('price', selectedSpawner.price);
    formData.append('iban', 'TR45 0001 5001 5800 7287 0048 22');
    formData.append('purchase_date', new Date().toLocaleString('tr-TR'));
    formData.append('recipient_email', 'furukonetwork@gmail.com');
    formData.append('subject', `Yeni ${selectedSpawner.name} Spawner Satın Alma - ${purchaseInfo.minecraftUsername}`);
    formData.append('message', `
Yeni Spawner Satın Alma Bildirimi

Spawner Türü: ${selectedSpawner.name}
Fiyat: ${selectedSpawner.price}

Oyuncu Bilgileri:
- Minecraft Kullanıcı Adı: ${purchaseInfo.minecraftUsername}
- E-posta: ${purchaseInfo.email}
- Discord: ${purchaseInfo.discord}

Ödeme Bilgileri:
- IBAN: TR45 0001 5001 5800 7287 0048 22
- Tarih: ${new Date().toLocaleString('tr-TR')}

Lütfen ödemeyi kontrol edin ve spawner'ı oyuncuya verin.
    `);

    try {
      await fetch('https://readdy.ai/api/form/d5l2cq1ubuu1ag7leou0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      setShowIbanModal(false);
      setShowSuccessModal(true);
      setPurchaseInfo({ minecraftUsername: '', email: '', discord: '' });
    } catch (error) {
      console.error('Form submission error:', error);
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  const copyIban = () => {
    navigator.clipboard.writeText('TR45 0001 5001 5800 7287 0048 22');
    alert('IBAN kopyalandı!');
  };

  return (
    <section className="relative py-24 px-6">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=minecraft%20cave%20texture%20with%20stone%20blocks%20dark%20underground%20atmosphere%20simple%20pattern%20background&width=1920&height=1080&seq=cave-texture-001&orientation=landscape"
          alt="Cave Texture"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4">
            Mevcut Spawner'lar
          </h2>
          <p className="text-xl text-cyan-400">
            Çiftliğini Genişlet
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {spawners.map((spawner, index) => (
            <div
              key={index}
              onClick={() => handlePurchaseClick(spawner)}
              className={`group relative bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border-2 border-transparent hover:border-current transition-all duration-300 hover:scale-110 hover:shadow-2xl cursor-pointer`}
              style={{
                borderImage: `linear-gradient(135deg, var(--tw-gradient-stops)) 1`,
                '--tw-gradient-from': spawner.color.split(' ')[0].replace('from-', ''),
                '--tw-gradient-to': spawner.color.split(' ')[2],
              } as React.CSSProperties}
            >
              <div className="aspect-square bg-gradient-to-br from-black/40 to-black/60 p-4">
                <div className="w-full h-full flex items-center justify-center">
                  <img
                    src={spawner.image}
                    alt={spawner.name}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
              </div>

              <div className={`bg-gradient-to-r ${spawner.color} p-4 text-center`}>
                <h3 className="text-xl font-bold text-white mb-1">{spawner.name}</h3>
                <p className="text-lg font-bold text-white">{spawner.price}</p>
              </div>

              <div className={`absolute inset-0 bg-gradient-to-r ${spawner.color} opacity-0 group-hover:opacity-20 transition-opacity pointer-events-none`}></div>
            </div>
          ))}
        </div>
      </div>

      {/* Purchase Modal */}
      {showPurchaseModal && selectedSpawner && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-cyan-500 rounded-2xl p-8 max-w-md w-full">
            <h3 className="text-3xl font-black text-white mb-6 text-center">
              {selectedSpawner.name} Spawner Satın Al
            </h3>
            <p className="text-2xl font-bold text-cyan-400 text-center mb-8">
              {selectedSpawner.price}
            </p>

            <form onSubmit={handlePurchaseSubmit} data-readdy-form className="space-y-4">
              <div>
                <label className="block text-white mb-2 font-semibold">
                  Minecraft Kullanıcı Adı
                </label>
                <input
                  type="text"
                  name="minecraft_username"
                  value={purchaseInfo.minecraftUsername}
                  onChange={(e) =>
                    setPurchaseInfo({ ...purchaseInfo, minecraftUsername: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/10 border-2 border-cyan-500/50 rounded-lg text-white focus:outline-none focus:border-cyan-400 transition-colors"
                  placeholder="Kullanıcı adınızı girin"
                  required
                />
              </div>

              <div>
                <label className="block text-white mb-2 font-semibold">E-posta</label>
                <input
                  type="email"
                  name="player_email"
                  value={purchaseInfo.email}
                  onChange={(e) =>
                    setPurchaseInfo({ ...purchaseInfo, email: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/10 border-2 border-cyan-500/50 rounded-lg text-white focus:outline-none focus:border-cyan-400 transition-colors"
                  placeholder="E-posta adresinizi girin"
                  required
                />
              </div>

              <div>
                <label className="block text-white mb-2 font-semibold">
                  Discord Kullanıcı Adı
                </label>
                <input
                  type="text"
                  name="discord_username"
                  value={purchaseInfo.discord}
                  onChange={(e) =>
                    setPurchaseInfo({ ...purchaseInfo, discord: e.target.value })
                  }
                  className="w-full px-4 py-3 bg-white/10 border-2 border-cyan-500/50 rounded-lg text-white focus:outline-none focus:border-cyan-400 transition-colors"
                  placeholder="Discord#1234"
                  required
                />
              </div>

              <div className="flex gap-4 mt-8">
                <button
                  type="button"
                  onClick={() => {
                    setShowPurchaseModal(false);
                    setPurchaseInfo({ minecraftUsername: '', email: '', discord: '' });
                  }}
                  className="flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-bold rounded-lg transition-colors whitespace-nowrap"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-bold rounded-lg transition-all whitespace-nowrap"
                >
                  Devam Et
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* IBAN Modal */}
      {showIbanModal && selectedSpawner && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-cyan-500 rounded-2xl p-8 max-w-md w-full">
            <h3 className="text-3xl font-black text-white mb-6 text-center">
              Ödeme Bilgileri
            </h3>

            <div className="bg-white/5 border-2 border-cyan-500/50 rounded-lg p-6 mb-6">
              <p className="text-cyan-400 font-semibold mb-2">IBAN Numarası:</p>
              <div className="flex items-center gap-2">
                <p className="text-white font-mono text-lg flex-1">
                  TR45 0001 5001 5800 7287 0048 22
                </p>
                <button
                  onClick={copyIban}
                  className="px-4 py-2 bg-cyan-500 hover:bg-cyan-400 text-white rounded-lg transition-colors whitespace-nowrap"
                >
                  <i className="ri-file-copy-line"></i>
                </button>
              </div>
            </div>

            <div className="bg-white/5 rounded-lg p-4 mb-6">
              <p className="text-white mb-2">
                <strong>Spawner:</strong> {selectedSpawner.name}
              </p>
              <p className="text-white mb-2">
                <strong>Fiyat:</strong> {selectedSpawner.price}
              </p>
              <p className="text-white">
                <strong>Oyuncu:</strong> {purchaseInfo.minecraftUsername}
              </p>
            </div>

            <p className="text-gray-400 text-sm mb-6 text-center">
              Ödemeyi yaptıktan sonra aşağıdaki butona tıklayın. Spawner'ınız en kısa sürede
              hesabınıza eklenecektir.
            </p>

            <div className="flex gap-4">
              <button
                onClick={() => {
                  setShowIbanModal(false);
                  setShowPurchaseModal(true);
                }}
                className="flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-bold rounded-lg transition-colors whitespace-nowrap"
              >
                Geri
              </button>
              <button
                onClick={handleConfirmPayment}
                className="flex-1 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-400 hover:to-emerald-500 text-white font-bold rounded-lg transition-all whitespace-nowrap"
              >
                Ödemeyi Onayla
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border-2 border-green-500 rounded-2xl p-8 max-w-md w-full text-center">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-5xl text-white"></i>
            </div>
            <h3 className="text-3xl font-black text-white mb-4">Başarılı!</h3>
            <p className="text-gray-300 mb-8">
              Satın alma talebiniz alındı. Ödemeniz onaylandıktan sonra spawner'ınız hesabınıza
              eklenecektir.
            </p>
            <button
              onClick={() => setShowSuccessModal(false)}
              className="px-8 py-3 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-400 hover:to-emerald-500 text-white font-bold rounded-lg transition-all whitespace-nowrap"
            >
              Tamam
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
